import _ from 'lodash';

function ImageModel(data) {
  data = data || {};

  return _.defaults(data, {
    workspace: 'root',
    category: 'image',
    disk: 'public',
    folder: '/images',
    isOverwrite: 'false',
    isSave: 'false',
    format: 'jpg',
    thumb: 150,
  });
}

export default ImageModel;
